// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1587":"FeatureStrategyBuilderRoutes","2076":"common","8415":"GayaRoutes"}[chunkId] || chunkId) + "." + {"1587":"595f52be99623a5f","2076":"fb3ea2271c7ab41d","8415":"2ff5895717529224","9009":"01444f1f8ede5823"}[chunkId] + ".css";
};